import cx from 'classnames'
import { MultiStepStepLayout } from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout'
import { useBrandProfile } from 'hooks/queries/brandProfiles/useBrandProfile'
import { BrandProfileStepProps } from './Types'
import VirtualMarketerOnboardingStyles from 'screens/VirtualMarketerOnboarding/VirtualMarketerOnboarding.module.scss'
import Styles from './BrandProfileWithEditing.module.scss'
import { BrandProfileWithEditing } from './BrandProfileWithEditing'
import { TopBar } from 'screens/VirtualMarketerOnboarding/TopBar/TopBar'

export const BrandProfileStep = ({ id, ...rest }: BrandProfileStepProps) => {
  const { data: brandProfile } = useBrandProfile(id, { cacheTime: 60 * 1000 * 5 })

  return (
    <MultiStepStepLayout
      scrollContainerClassName={cx(VirtualMarketerOnboardingStyles.scrollContainer, Styles.scrollContainer)}
    >
      <TopBar highlightStep="yourBusiness" />
      {brandProfile && <BrandProfileWithEditing brandProfile={brandProfile} {...rest} />}
    </MultiStepStepLayout>
  )
}
